import React from 'react';
import {
  Body,
  Heading,
  Col,
  FlexRow,
  Image,
  Divider,
  FlightRightIcon,
  Box,
} from '@edreamsodigeo/prisma-design-system';

import { useTranslation } from '@edreamsodigeo/frontend-core';
import { PriceFreezeTime } from '@/components/PriceFreezeDateTime/PriceFreezeDateTime';
import { differenceInDays, startOfDay } from 'date-fns';

const last = (arr) => arr[arr.length - 1];

export function CarrierLogo({ carrierId }) {
  return (
    <Image
      src={`/images/onefront/airlines/sm${carrierId}.gif`}
      alt={`carrier logo ${carrierId}`}
      size="medium"
      rounded
      inline
    />
  );
}

export function getDuration(duration) {
  const hours = Math.floor(duration / 60);
  const minutes = Math.floor(duration % 60);

  return {
    hours,
    minutes,
  };
}

export function SectionDetails({ location, datetime, daysDiff }) {
  return (
    <>
      <Heading type={{ _: '4', md: '3', lg: '3' }} color="neutral.100">
        <PriceFreezeTime
          type="time"
          pattern="short"
          date={datetime}
          daysDiff={daysDiff}
        />
      </Heading>
      <Body type="base" color="neutral.70">
        {location}
      </Body>
    </>
  );
}

export function SegmentDetails({ segment }) {
  const { t } = useTranslation();
  const numberOfSections = segment.sections.length;
  const numberOfStops = numberOfSections - 1;
  const isDirect = numberOfStops === 0;
  const departureDate = segment.sections[0].departureDate;
  return (
    <FlexRow justifyContent="space-between" gap={3}>
      <Col>
        <SectionDetails
          location={segment.sections[0].departure.iata}
          datetime={departureDate}
        />
      </Col>
      <Col flexGrow={2}>
        <FlexRow justifyContent="center" alignItems="center" gap={2}>
          <Col flexGrow={2}>
            <Divider
              orientation="horizontal"
              type="dashed"
              color="neutral.50"
            />
          </Col>
          <Col>
            <Body textAlign="center">
              <FlightRightIcon size="medium" color="primary.50" />
            </Body>
          </Col>
          <Col flexGrow={2}>
            <Divider
              orientation="horizontal"
              type="dashed"
              color="neutral.50"
            />
          </Col>
        </FlexRow>
        <Body
          textAlign="center"
          as="p"
          type="small"
          color="neutral.70"
          aria-label="sectionContent"
        >
          {t('itinerarydetails.duration', getDuration(segment.duration))} • {''}
          {t('itinerarydetails.segment.stops', {
            count: numberOfStops,
            context: isDirect ? 'none' : 'some',
          })}
        </Body>
      </Col>
      <Col>
        <Box pr="2x_small">
          <SectionDetails
            location={last(segment.sections).destination.iata}
            datetime={last(segment.sections).arrivalDate}
            daysDiff={getDaysDiff(last(segment.sections))}
          />
        </Box>
      </Col>
    </FlexRow>
  );
}

function getDaysDiff(section) {
  return differenceInDays(
    startOfDay(Date.parse(section.arrivalDate)),
    startOfDay(Date.parse(section.departureDate))
  );
}
